import React from 'react';

const ProgressTrackerPlaceholder = ({ onBack }) => {
  return (
    <div className="p-6">
      <div className="flex items-center gap-4 mb-6">
        <button
          onClick={onBack}
          className="p-2 hover:bg-[#F3D5B5]/20 rounded-lg transition-colors"
        >
          <svg className="w-5 h-5 text-[#2A324B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h2 className="text-xl font-semibold text-[#2A324B]">Track Skin Progress</h2>
      </div>
      
      <div className="text-center py-12">
        <div className="w-16 h-16 bg-[#F3D5B5] rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-[#2A324B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-[#2A324B] mb-2">Coming Soon!</h3>
        <p className="text-[#2A324B]/70 max-w-sm mx-auto">
          This feature will allow you to upload progress photos, rate your skin daily, and track improvements over time.
        </p>
      </div>
    </div>
  );
};

export default ProgressTrackerPlaceholder;
